<template>
  <div>
    <cdr-banner type="error">{{ message }}</cdr-banner>
  </div>
</template>

<script>
import { CdrBanner } from '@rei/cedar';

export default {
  name: 'ErrorModal',
  components: {
    CdrBanner,
  },
  props: {
    message: { type: String, required: true },
  },
};
</script>
